import { Pipe, PipeTransform } from '@angular/core'

import { Survey } from "app/shared/model/index";
import { FollowupOnsiteGuestFilter } from 'app/states/followup-onsite/followup-onsite.state';

@Pipe({
    name: 'followupOnsiteCountriesFilter',
    standalone: false
})
export class FollowupOnsiteCountriesFilterPipe implements PipeTransform {

  transform(value: Survey[], filters: FollowupOnsiteGuestFilter): Survey[] {
    if(filters.countries) {
      const filtered = value.filter(survey => !!filters.countries.find(country => country === survey.guest.country.code) )
      if(filtered?.length > 0) return filtered
      else return value
    } else
      return value
  }
}
